import React from 'react';
import { withRouter } from "react-router-dom";

import UserService from 'shared/services/UserService';
import Loading from 'shared/components/Loading';
import Login from 'app/screens/Login';
import CustomLoading from 'shared/components/CustomLoading/CustomLoading';

let userService = new UserService();

class UpdatePassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      loggedIn: false
    }
  }

  componentDidMount() {
    const token = this.props.match.params.token;

    userService.passwordResetLogin({ token })
      .then(() => {
        this.setState({ loading: false, loggedIn: true });
      })
      .catch(err => {
        console.error(err);
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) {
      return <CustomLoading />;
    }

    if (!this.state.loggedIn) {
      return <Login resetTokenExpired={true} />;
    }

    return <Login updatePassword={true} />;
  }
}

export default withRouter(UpdatePassword);
